import { Booking } from 'components/EventCalendar/types';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    booking: Booking;
    /** Rendered after the amount — the edit affordance. */
    children?: ReactNode;
}

/** The booking's price as plain, right-aligned text so the amounts line up down the column. */
export const PriceComponent = ({ booking, children }: Props) => {
    const { t } = useTranslation('bookings');
    const priceText = `${Number(booking.price).toLocaleString('de', { minimumFractionDigits: 2 })} €`;
    const voucherText =
        booking.usedVouchers?.length > 0
            ? t('booking.list.price.withVoucher', {
                  vouchers: booking.usedVouchers.map((v) => '#' + String(v)).join(',')
              })
            : '';

    return (
        <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-align-middle">
            {booking.price_data?.price_before_override && (
                <span className="tw-text-xs tw-text-accents-6 tw-line-through">
                    {Number(booking.price_data?.price_before_override).toLocaleString('de', {
                        minimumFractionDigits: 2
                    })}
                    €
                </span>
            )}
            <span className="tw-font-medium tw-tabular-nums tw-text-accents-9">
                {priceText}
            </span>
            {voucherText && <span className="tw-text-xs tw-text-accents-6">{voucherText}</span>}
            {children}
        </span>
    );
};
